<div class="container-fluid h-100">
  <as-split direction="vertical" [gutterSize]="20">
    <as-split-area [size]="50" [order]="1">
      <div class="h-100">
        <as-split direction="horizontal" [gutterSize]="20">
          <as-split-area [size]="50" [order]="1">
            <div class="flex-column h-100">
              <app-fsl-groups
                (selectItems)="groupsSelectionChanged($event)"
              ></app-fsl-groups>
            </div>
          </as-split-area>
          <as-split-area [size]="50" [order]="2">
            <div class="flex-column h-100">
              <app-fsl-locations
                *ngIf="!uiGridState"
                (selectItems)="locationsSelectionChanged($event)"
                (uiGridToggle)="uiGridToggle()"
                [frequency]="currentFrequency"
                [state]="currentState"
                [labour]="currentLabour"
              ></app-fsl-locations>
              <app-fsl-plans
                *ngIf="uiGridState"
                (selectItems)="plansSelectionChanged($event)"
                (uiGridToggle)="uiGridToggle()"
                [frequency]="currentFrequency"
                [state]="currentState"
                [labour]="currentLabour"
              ></app-fsl-plans>
            </div>
          </as-split-area>
        </as-split>
      </div>
    </as-split-area>
    <as-split-area [size]="50" [order]="2">
      <div class="row h-100">
        <div class="flex-column h-100 col-12">
          <app-fsl-tasks
            [frequency]="currentFrequency"
            [state]="currentState"
            [labour]="currentLabour"
            [loadFrom]="loadFrom"
            [currentSelection]="currentSelection"
          ></app-fsl-tasks>
        </div>
      </div>
    </as-split-area>
  </as-split>
</div>
